/* MASONTEX · Media Core — delivery.js (flat asset path)
   Responsive media delivery. DOM-free.
   Caps interactive image requests for mobile and desktop viewports.
   Preserves asset identity: only adds width param — filename + version token
   stay intact, so sameAsset() behavior is unaffected. */
(function (global) {
  'use strict';

  const api = (global.MasontexMediaCore = global.MasontexMediaCore || {});
  const delivery = {};

  /* Matches the phone breakpoint used by ms-product-template-parity.css. */
  delivery.MOBILE_BREAKPOINT = 749;
  /* 2x of the ~390px mobile stage width. */
  delivery.MOBILE_WIDTH = 780;
  /* The desktop media stage is ~680 CSS px; 1600px preserves high-DPI detail. */
  delivery.DESKTOP_WIDTH = 1600;

  delivery.transformUrl = (url, options) => {
    if (!url) return url;
    const value = String(url);
    const width = Number(options && options.width);
    if (!(width > 0)) return value;
    /* Shopify uploaded-file CDN only; leave every other URL untouched. */
    if (!/\/files\//.test(value)) return value;
    try {
      const parsed = new URL(value, 'https://cdn.shopify.com');
      const params = new URLSearchParams(parsed.search);
      params.set('width', String(Math.round(width)));
      parsed.search = params.toString();
      return parsed.toString();
    } catch (error) {
      return value;
    }
  };

  delivery.transformPayload = (payload, options) => {
    if (!payload) return payload;
    return {
      base: delivery.transformUrl(payload.base, options),
      overlay: delivery.transformUrl(payload.overlay, options),
      filter: payload.filter
    };
  };

  delivery.widthForViewport = (viewportWidth, options) => {
    const settings = options || {};
    const breakpoint = Number(settings.mobileBreakpoint) > 0 ? Number(settings.mobileBreakpoint) : delivery.MOBILE_BREAKPOINT;
    const mobileWidth = Number(settings.mobileWidth) > 0 ? Number(settings.mobileWidth) : delivery.MOBILE_WIDTH;
    const desktopWidth = Number(settings.desktopWidth) > 0 ? Number(settings.desktopWidth) : delivery.DESKTOP_WIDTH;
    return viewportWidth <= breakpoint ? mobileWidth : desktopWidth;
  };

  api.delivery = delivery;
})(typeof window !== 'undefined' ? window : globalThis);
